var _defs, _path, _path2, _polyline, _polyline2, _path3, _circle, _polyline3, _circle2, _polyline4, _circle3, _line, _circle4, _polyline5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportStory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xD1\\xEB\\xEE\\xE9_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1183.6 1333.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{stroke-linejoin:round;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{fill:none;stroke-width:10px;}.cls-1,.cls-2,.cls-3,.cls-5{stroke-linecap:round;}.cls-1,.cls-2,.cls-4,.cls-5{fill-rule:evenodd;}.cls-1,.cls-5{stroke:#000;}.cls-2,.cls-3,.cls-4{stroke:#282f39;}.cls-4,.cls-5{stroke-miterlimit:22.93;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M589.29,206.19c-252.71,1.35-457.15,206.63-457.15,459.65,0,190.25,115.59,353.51,280.36,423.38M589.36,1125.5c.81,0,1.63,0,2.44,0,253.86,0,459.66-205.8,459.66-459.66,0-189.96-115.23-353-279.6-423.05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M589.55,1252.64c.75,0,1.5,0,2.25,0,223.08,0,417.09-124.48,516.35-307.78M1137.91,880.99c26.26-66.62,40.69-139.19,40.69-215.14,0-17.24-.75-34.32-2.21-51.19M1155.47,502.26c-5.07-17.51-10.95-34.68-17.57-51.48M589.28,79.05c-222.83.94-416.34,126.07-514.9,309.76M44.58,453.55c-25.56,65.83-39.58,137.43-39.58,212.29,0,17.9.81,35.63,2.38,53.15M28.77,831.53c5.13,17.43,11.04,34.53,17.71,51.26"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "589.32 79.06 589.32 5 805.32 144.2 589.32 282.2 589.32 206.19"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "589.33 1125.48 589.33 1051.76 361.93 1190.37 589.33 1328.97 589.33 1252.67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M558.26,343.29h67.08c7.6,0,12.43,6.35,13.82,13.82,4.05,21.78,7.46,77.32,27.3,90.1,8.63,2.93,17.03,6.36,25.17,10.25l2.72,1.33c23.05,5.07,64.79-31.85,83.07-44.4,6.27-4.3,14.17-5.37,19.54,0l23.05,23.05,24.39,24.39c5.37,5.37,4.3,13.28,0,19.54-12.55,18.28-49.47,60.03-44.4,83.08.59,1.19,1.17,2.38,1.73,3.59,3.19,6.76,6.07,13.7,8.61,20.8.42,1.17.84,2.33,1.24,3.51,12.78,19.84,68.31,23.25,90.1,27.29,7.47,1.39,13.82,6.22,13.82,13.82v67.08c0,7.6-6.35,12.43-13.82,13.82-21.79,4.05-77.32,7.46-90.1,27.3-.4,1.18-.82,2.34-1.24,3.51-2.54,7.1-5.42,14.04-8.61,20.8l-1.73,3.58c-5.07,23.05,31.85,64.79,44.4,83.07,4.3,6.27,5.37,14.17,0,19.54l-23.05,23.05-24.39,24.39c-5.37,5.37-13.28,4.3-19.54,0-18.28-12.55-60.04-49.47-83.09-44.39l-2.72,1.33c-6.98,3.33-14.15,6.32-21.49,8.95-1.22.44-2.44.87-3.66,1.29-19.84,12.78-23.25,68.31-27.3,90.1-1.39,7.47-6.22,13.82-13.82,13.82h-67.08c-7.6,0-12.43-6.35-13.82-13.82-4.05-21.79-7.46-77.32-27.29-90.1-.81-.28-1.61-.57-2.42-.85-7.7-2.71-15.22-5.81-22.53-9.29l-2.94-1.43c-23.05-5.07-64.8,31.84-83.08,44.4-6.26,4.3-14.17,5.37-19.54,0l-23.05-23.05-24.39-24.39c-5.37-5.37-4.3-13.28,0-19.54,12.56-18.28,49.48-60.02,44.4-83.07-.34-.7-.7-1.39-1.03-2.09-3.62-7.53-6.83-15.28-9.64-23.23-.3-.86-.61-1.71-.91-2.57-12.78-19.84-68.31-23.25-90.1-27.3-7.47-1.39-13.82-6.22-13.82-13.82v-67.08c0-7.6,6.35-12.43,13.82-13.82,21.78-4.05,77.31-7.46,90.09-27.29.29-.87.61-1.72.91-2.58,2.81-7.95,6.02-15.71,9.64-23.24.34-.7.69-1.39,1.03-2.09,5.06-23.05-31.85-64.78-44.41-83.06-4.3-6.27-5.37-14.17,0-19.54l23.05-23.05,24.39-24.39c5.37-5.37,13.28-4.3,19.54,0,18.27,12.54,59.97,49.43,83.03,44.42l2.97-1.45c8.09-3.86,16.45-7.26,25.03-10.17,19.79-12.84,23.2-68.31,27.24-90.08,1.39-7.47,6.22-13.82,13.82-13.82Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 608.97,
    cy: 807.12,
    r: 45.69,
    transform: "translate(-402.04 794.46) rotate(-52.25)"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "581.03 770.96 525.28 713.85 443.57 713.94"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 559.57,
    cy: 526.84,
    r: 45.69,
    transform: "translate(-37.42 1010.87) rotate(-82.31)"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "531.63 563.01 475.88 620.12 443.67 620.08"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 706.35,
    cy: 666.98,
    r: 45.69,
    transform: "translate(-16.63 1315.91) rotate(-85.27)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 660.65,
    y1: 666.98,
    x2: 431.56,
    y2: 668.85
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 680.76,
    cy: 550.33,
    r: 37.47,
    transform: "translate(-145.28 840.1) rotate(-58.28)"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "656.43 578.83 612.35 624.27 515.17 625.41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportStory);
export default __webpack_public_path__ + "static/media/importStory.5713f0d24e3506cd1dbaf2dad64cb52b.svg";
export { ForwardRef as ReactComponent };